export function handleBadgeData(badgeData) {
  const badge = {
    receiptConfirmationNew: '',
    breachManegement: badgeData.breachApply && badgeData.breachApply != 0 ? badgeData.breachApply + '' : '',
    ensureSendGoods: badgeData.deliverOrderNum && badgeData.deliverOrderNum != 0 ? badgeData.deliverOrderNum + '' : '',
    abnormalWayBill:
      badgeData.exceptionOrderCount && badgeData.exceptionOrderCount != 0 ? badgeData.exceptionOrderCount + '' : '',
    orderOverDue:
      badgeData.orderOverDueCount && badgeData.orderOverDueCount != 0 ? badgeData.orderOverDueCount + '' : '',
    yccl:
      badgeData.exceptionHandlingCount && badgeData.exceptionHandlingCount != 0
        ? badgeData.exceptionHandlingCount + ''
        : '',
    settlementApplication: '',
    receiptSign: '',
    contractManagement: '',
    cancellationRecord:
      badgeData.cancellationRecord && badgeData.cancellationRecord != 0 ? badgeData.cancellationRecord + '' : '',
    outBound:
      badgeData?.appointmentGuideCount && badgeData?.appointmentGuideCount != 0
        ? badgeData?.appointmentGuideCount + ''
        : ''
  };

  if (badgeData.workOrder && typeof badgeData.workOrder == 'object' && badgeData.workOrder.totalSize) {
    if (badgeData.workOrder.totalSize != 0) {
      badge.receiptConfirmationNew = badgeData.workOrder.totalSize + '';
    }
  } else {
    if (badgeData.workOrder && badgeData.workOrder != 0) {
      badge.receiptConfirmationNew = badgeData.workOrder + '';
    }
  }
  if (badgeData.applySettleCount && badgeData.applySettleCount.model && badgeData.applySettleCount.model != 0) {
    badge.settlementApplication = badgeData.applySettleCount.model + '';
  } else {
    if (badgeData.applySettleCount && badgeData.applySettleCount != 0) {
      badge.settlementApplication = badgeData.applySettleCount + '';
    }
  }
  if (badgeData.expressCount && typeof badgeData.expressCount == 'object') {
    if (badgeData.expressCount.consignorCount && badgeData.expressCount.consignorCount != 0) {
      badge.receiptSign = badgeData.expressCount.consignorCount + '';
    }
  } else {
    if (badgeData.expressCount && badgeData.expressCount != 0) {
      badge.receiptSign = badgeData.expressCount + '';
    }
  }
  if (badgeData.signatureCount && badgeData.signatureCount > 0) {
    badge.contractManagement = '签';
  }
  if (badgeData?.appointmentGuideCount && badgeData?.appointmentGuideCount > 0) {
    badge.outBound = badgeData?.appointmentGuideCount + '';
  }
  return badge;
}

export const badgeMenus = [
  'receiptConfirmationNew',
  'breachManegement',
  'ensureSendGoods',
  'abnormalWayBill',
  'orderOverDue',
  'settlementApplication',
  'receiptSign',
  'contractManagement',
  'cancellationRecord',
  'yccl',
  'outBound'
];
